import { ProfileComponent } from './profile/profile.component';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AgGridModule } from 'ag-grid-angular';

import { AppComponent } from './app.component';
import { SidebarComponent } from './shared/sidebar/sidebar.component';
import { AuthModule } from './auth/auth.module';
import { NgbPaginationModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FullComponent } from './layouts/full/full.component';
import { BlankComponent } from './layouts/blank/blank.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthGuard } from './shared/guard/auth.guard';
import { GoogleMapsModule } from '@angular/google-maps'
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { DashboardModule } from './dashboard/dashboard.module';
import { CustomerManagementModule } from './customer-management/customer-management.module'; 
import { AnalyticsModule } from './analytics/analytics.module';
import { DevicesModule } from './Devices/devices.module';
import { RouterModule } from '@angular/router';
import { NgHttpLoaderModule } from 'ng-http-loader';
import { routes } from './app-routing.module';
import { LoaderComponent } from './shared/loader/loader.component'
import { LoaderInterceptor } from './shared/interceptor/loader.interceptor';
import { CommonModule, HashLocationStrategy, LocationStrategy } from '@angular/common';
import { AuthInterceptor} from './shared/interceptor/auth.interceptor';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DataSharedService } from './shared/services/data-shared.service';
import { EmitterService } from './shared/services/event-service';
import { WidgetsModule } from './widgets/widgets.module'
import { ToastrModule } from 'ngx-toastr';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MasterComponent } from './layouts/master/master.component';
import { ControlPanelComponent } from './partials/control-panel/control-panel.component';
import { HeaderComponent } from './partials/header/header.component';
import { MainSidebarComponent } from './partials/main-sidebar/main-sidebar.component';
import { StatusComponent } from './status/status.component';
import { AlarmLogsComponent } from './alarm-logs/alarm-logs.component';
import { SettingsComponent } from './settings/settings.component';
import { RecursiveControlPanelComponent } from './components/recursive-control-panel/recursive-control-panel.component';
import { RecursiveSidebarMenuComponent } from './components/recursive-sidebar-menu/recursive-sidebar-menu.component';
import { FavoriteComponent } from './favorite/favorite.component';
import { PvNetMeteringComponent } from './pv-net-metering/pv-net-metering.component';
import { PvStringMonitoringComponent } from './pv-string-monitoring/pv-string-monitoring.component';
import { ChartsComponent } from './charts/charts.component';
import { SolarCardsComponent } from './components/solar-cards/solar-cards.component';
import { NgxPrintModule } from 'ngx-print';
import { BillingSummaryComponent } from './billing-summary/billing-summary.component';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { AgmCoreModule } from '@agm/core';
import { ButtonManagementComponent } from './button-management/button-management.component';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { PowerMonitoringComponent } from './power-monitoring/power-monitoring.component';
import { PvGenrationReportComponent } from './pv-genration-report/pv-genration-report.component';
import { EmailAlertComponent } from './components/email-alert/email-alert.component';
import { FlowTrackingComponent } from './flow-tracking/flow-tracking.component';
import { FlowTrackingCardsComponent } from './components/flow-tracking/flow-tracking-cards/flow-tracking-cards.component';
import { FlowTrackingChartComponent } from './components/flow-tracking/flow-tracking-chart/flow-tracking-chart.component';
import { DateRangePickerComponent } from './components/date-range-picker/date-range-picker.component';
import { ModalComponent } from './components/flow-tracking/modal/modal.component';

@NgModule({
 
  declarations: [
    AppComponent,
    SidebarComponent,
    FullComponent,
    BlankComponent,
    LoaderComponent,
    ProfileComponent,
    MasterComponent,
    ControlPanelComponent,
    HeaderComponent,
    MainSidebarComponent,
    StatusComponent,
    AlarmLogsComponent,
    SettingsComponent,
    RecursiveControlPanelComponent,
    RecursiveSidebarMenuComponent,
    FavoriteComponent,
    PvNetMeteringComponent,
    PvStringMonitoringComponent,
    ChartsComponent,
    SolarCardsComponent,
    BillingSummaryComponent,
    ButtonManagementComponent,
    PowerMonitoringComponent,
    PvGenrationReportComponent,
    EmailAlertComponent,
    FlowTrackingComponent,
    FlowTrackingCardsComponent,
    FlowTrackingChartComponent,
    DateRangePickerComponent,
    ModalComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    AuthModule,
    DashboardModule,
    DevicesModule,
    CustomerManagementModule,
    HttpClientModule,
    GoogleMapsModule,
    FormsModule,
    ReactiveFormsModule,    
    NgHttpLoaderModule.forRoot(),
    CommonModule,
    NgbModule,
    NgbPaginationModule,
    RouterModule.forRoot(routes),
    BrowserAnimationsModule,
    // ChartsModule,
    // GaugeModule.forRoot(),
    ToastrModule.forRoot(),
    WidgetsModule,
    ScrollingModule,
    AnalyticsModule,
    NgMultiSelectDropDownModule.forRoot(),
    NgxPrintModule,
    NgxDaterangepickerMd.forRoot(),
    AgmCoreModule.forRoot({
      // please get your own API key here:
      // https://developers.google.com/maps/documentation/javascript/get-api-key?hl=en
      apiKey: 'AIzaSyBtsD_tq5mK7-coGTZGpMOelwaq_8maEv8'
    }),
    Ng2SearchPipeModule
    ,
    AgGridModule.withComponents([])
  ],
  providers: [AuthGuard, DataSharedService, EmitterService,
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }